import React from 'react';
import type { LinkedWiki } from '../../types/wiki';

// 「哪几页 wiki 来自/对应这次会话」。与本目录 LinkedTasks 是对称的一对，
// 数据来自 WorklogPresenter#linked_wikis_json。
//
// 没有关联时整块不渲染，照 LinkedTasks 的先例：日志写完就冻住了，
// 没关联是常态不是缺失。

type LinkedWikisProps = {
  wikis: LinkedWiki[];
};

const LinkedWikis: React.FC<LinkedWikisProps> = ({ wikis }) => {
  if (wikis.length === 0) return null;

  return (
    <div className="mb-6">
      <div className="mb-2 flex items-baseline gap-2">
        <span className="text-sm font-semibold">关联的 wiki</span>
        <span className="rounded-full border border-gray-200 px-1.5 py-px font-mono text-[11px] text-gray-500">
          {wikis.length}
        </span>
      </div>

      {wikis.map((wiki) => (
        <a
          key={wiki.url_key}
          href={`/wiki/${wiki.url_key}`}
          className="mb-1.5 flex items-center gap-2.5 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 no-underline last:mb-0 hover:border-gray-300"
        >
          <span className="min-w-0 flex-1 truncate text-[13px] leading-snug text-gray-900">
            {wiki.title}
          </span>
        </a>
      ))}
    </div>
  );
};

export default LinkedWikis;
